const NAV_ACCOUNT_MENU_OPENED_CLASS = 'nav-account-menu-opened'

export const resolveMultipleScrollLayers = () => {
    const bodyElement = document.getElementsByTagName('body')[0]
    if(bodyElement.classList.contains(NAV_ACCOUNT_MENU_OPENED_CLASS)) {
        bodyElement.classList.remove(NAV_ACCOUNT_MENU_OPENED_CLASS)
    } else {
        bodyElement.classList.add(NAV_ACCOUNT_MENU_OPENED_CLASS)
    }
}